import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Button} from '@stubhub/bamboo';
import {ENTITY_TYPE_VENUE} from '@stubhub/entity-helper';
import {CloudinaryImage, helper} from '@stubhub/react-cloudinary';

import {DEFAULT_IMAGE_CONFIG} from '../../utils/cloudinaryConfigs';
import Card, {CardImage} from '../react-card';

import './index.scss';

/**
 * Side rail panel for entity details such as imagery and links to related content
 */
class EntitySideRailDetails extends Component {
  static contextTypes = {
    track: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
  }

  scrollToReadMore = (e) => {
    e.preventDefault();
    const {readMoreRef} = this.props;

    /* istanbul ignore next */
    if (readMoreRef && typeof readMoreRef.scrollIntoView === 'function') {
      /* istanbul ignore next */
      readMoreRef.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  };

  render() {
    const {entityImageClass, src, publicIdSrc, source, entityName, entityId, entityType, showSeeMore} = this.props;
    const entitySellLink = `/sell/searchEvent?id=${entityId}&type=performer&q=${entityName}`;
    let cardImage = null;
    if (entityType !== ENTITY_TYPE_VENUE) {
      const entityImageOptions = {
        src,
        publicIdSrc,
        ...DEFAULT_IMAGE_CONFIG,
      };
      const entityImageUrl = helper.getCloudinaryImage(entityImageOptions);
      const entityImage = entityImageUrl ? (
        <CloudinaryImage className={entityImageClass} image={entityImageUrl} alt={entityName} />
      ) : null;
      cardImage = entityImage && (
        <CardImage
          className="EntitySideRailDetails__imageContainer"
          image={entityImage}
          alt={entityName}
          attribution={source}
          useSkeleton={false}
        />
      );
    }

    return (
      <Card className="EntitySideRailDetails__container" image={cardImage}>
        <div className="EntitySideRailDetails__linksContainer">
          {showSeeMore && (
            <Button
              className="EntitySideRailDetails__link"
              appearance="secondary"
              onClick={this.scrollToReadMore}
              fullWidth
              href="#seo-bottom-content"
            >
              <FormattedMessage id="EntitySideRailDetails.seeMore" defaultMessage="See more" />
            </Button>
          )}
          <Button className="EntitySideRailDetails__link" href={entitySellLink} appearance="primary" fullWidth>
            <FormattedMessage id="EntitySideRailDetails.sell-tickets" defaultMessage="Sell tickets" />
          </Button>
        </div>
      </Card>
    );
  }
}

EntitySideRailDetails.propTypes = {
  /** Class name for entity image */
  entityImageClass: PropTypes.string,

  /** The image src */
  src: PropTypes.string,

  /* Image attribution to add to the image */
  source: PropTypes.string,

  /** Entity name */
  entityName: PropTypes.string.isRequired,

  /** The id associated to the Entity. */
  entityId: PropTypes.string.isRequired,

  /** Reference to the read more element */
  readMoreRef: PropTypes.object,

  /** Whether to show the see more button */
  showSeeMore: PropTypes.bool,

  /** Cloudinary ID */
  publicIdSrc: PropTypes.string,

  /** Type of entity (venue, performer, city, ...) */
  entityType: PropTypes.string,
};

export default EntitySideRailDetails;
